import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CompanySettingsPage } from '@/areas/settings/CompanySettings/CompanySettingsPage';
import { canViewCompanySettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/company')({
    staticData: { access: { permissions: canViewCompanySettings }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CompanySettingsPage />;
}
